import { AsYouType } from "libphonenumber-js";

/**
 * 電話番号のフォーマット（ハイフン）に整形する
 * @param phoneNumber 電話番号
 */
const formatTel = function(phoneNumber) {
  return new AsYouType("JP").input(phoneNumber);
};

/**
 * 0パディング（0で桁埋め）に整形する
 * @param num  数字
 * @param length 桁数
 */
function zeroPadding(num, length) {
  return ("0000000000" + num).slice(-length);
}

export default {
  formatTel,
  zeroPadding
};
